// hooks/useSectionInView.ts
import { useEffect, useState } from 'react';

export const useSectionInView = (ref: React.RefObject<HTMLElement>, threshold = 0) => {
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsInView(entry.isIntersecting);
      },
      {
        threshold,
        rootMargin: '0px 0px -100% 0px', // 상단 진입 감지
      }
    );

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref, threshold]);

  return isInView;
};
